import { ComponentType, ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { DataProvider } from './Providers/DataProvider'
import { FilterProvider } from './Providers/FiltersProvider'
import { FinancialWorkspaceProvider } from './Providers/Provider'
import { TotalProvider } from './Providers/TotalProvider'
import { DateNavigator } from './components/DateNavigator'
import { Filters } from './components/Filters'
import { Table } from './components/Table'
import { CustomizableTableProps } from './components/Table/types'
import { UseAdditionalFilters } from './types/filter'
import { InsightTableGroupBy, InsightTableType } from './types/table'

interface FinancialWorkspaceProps {
  chart?: JSX.Element
  header?: React.ReactNode
  blurTable?: React.ReactNode
  insightTableType: InsightTableType
  defaultGroupBy: InsightTableGroupBy
  tableProps?: CustomizableTableProps
  customPeriodComponent?: React.ReactNode
  useAdditionalFilters?: UseAdditionalFilters
  renderLandingBanner?: () => React.ReactNode
  dataProvider?: ComponentType<{ children: ReactNode }>
}

export const FinancialWorkspace = ({
  chart,
  header,
  blurTable,
  tableProps,
  dataProvider,
  defaultGroupBy,
  insightTableType,
  renderLandingBanner,
  useAdditionalFilters,
  customPeriodComponent,
}: FinancialWorkspaceProps) => {
  const content = () => {
    if (renderLandingBanner) {
      return renderLandingBanner()
    }

    return (
      <DataProvider Provider={dataProvider}>
        {header && <Box paddingBottom="s16">{header}</Box>}
        <Box flexDirection="row" justifyContent="spaceBetween" gap="s16">
          <Box overflowX="auto">
            <Filters useAdditionalFilters={useAdditionalFilters} />
          </Box>

          <Box flexDirection="row" gap="s8">
            {customPeriodComponent && customPeriodComponent}
            <DateNavigator />
          </Box>
        </Box>
        <TotalProvider>
          {chart && <Box paddingTop="s16">{chart}</Box>}

          {blurTable ||
            (tableProps && (
              <Table
                tableProps={tableProps}
                defaultGroupBy={defaultGroupBy}
                useAdditionalFilters={useAdditionalFilters}
              />
            ))}
        </TotalProvider>
      </DataProvider>
    )
  }
  return (
    <FilterProvider type={insightTableType}>
      <FinancialWorkspaceProvider
        defaultGroupBy={defaultGroupBy}
        insightTableType={insightTableType}
      >
        {content()}
      </FinancialWorkspaceProvider>
    </FilterProvider>
  )
}
